import { Chip } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export type FilterCountChipProps = {
  count: number;
};

export const FilterCountChip: React.FC<FilterCountChipProps> = props => {
  const { classes } = useStyles();

  return (
    <Chip variant="filled" color="secondary" size="small" label={props.count} classes={{ root: classes.root, label: classes.chipLabel }} />
  );
};

const useStyles = makeStyles()(() => ({
  root: {
    height: '20px',
  },
  chipLabel: {
    fontSize: '12px',
    fontWeight: 500,
    padding: '0px 6px',
    lineHeight: 1
  }
}));
